import React, { useState, useEffect, useRef } from "react";

import {
  Box,
  Grid,
  Button,
  Typography,
  IconButton,
  Card,
  CardContent,
  CardHeader,
  Tabs,
  Tab,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Snackbar,
  TextField,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";

import {
  Inbox as InboxIcon,
  Edit as EditIcon,
  Save as SaveIcon,
  Delete as DeleteIcon,
  AccountCircle as AccountCircleIcon,
  QrCode as CodeIcon,
  Apartment as ApartmentIcon,
  LocationOn as LocationOnIcon,
  Place as PlaceIcon,
  Pin as PinIcon,
  Public as PublicIcon,
  Flag as FlagIcon,
  LocationCity as LocationCityIcon,
  Info as InfoIcon,
  Add as AddIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
} from "@mui/icons-material";

import Header from "../OrderManagement/Header";
import CustomerListPage from "../Customer/List";
import PopupMessage from "../../ui/PopupMessage";

import { headers } from "../../utils/utils";


const ShowPage = ({ id }) => {
    const [customerData, setCustomerData] = useState({
        customerName: '',
        customerCode: '',
        customerType: 'Customer',
        CustomerEmail: '',
        customerPhoneNumber : '',
        addresses: [
            {
                unitNumber: '',
                addressLine1: '',
                addressLine2: '',
                zipcode: '',
                country: '',
                state: '',
                city: '',
                addressType: 'Billing Address',
            },
        ],
        bank: []
        
    });

  const debounceTimeoutRef = useRef(null);
  const [tabValue, setTabValue] = useState(0);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editMode, setEditMode] = useState({});
  const [messageOpen, setMessageOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("success");
  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState({}); // Store states based on address index
  const [cities, setCities] = useState({}); // Store cities based on address index

  const addNewBank = () => {
    const newBank = {
      accountHolderName: "",
      accountNumber: "",
      accountType: "",
      bankName: "",
      branchName: "",
      ifscCode: "",
    };
    setCustomerData((prevData) => ({
      ...prevData,
      bank: [...(prevData.bank || []), newBank],
    }));
  };

  useEffect(() => {
    fetchCustomerShow();
  }, []);

  useEffect(() => {
    console.log("Updated customer data:", customerData);
  }, [customerData]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleEditToggle = (field) => {
    setEditMode((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const handleEditAddressToggle = (index, field) => {
    setEditMode((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        [field]: !prev[index]?.[field], // Toggle specific field for specific address
      },
    }));
  };

  const fetchCustomerShow = async (field, value) => {
    const response = await fetch(
      process.env.REACT_APP_CUSTOMER + "/customer/show/" + id,
      {
        method: "GET",
        headers: headers(),
      },
    );

    if (response.ok) {
      const data = await response.json();
      console.log("Fetched Customer Data:", data); // Debug
      setCustomerData(data);
    } else {
      console.error("Failed to fetch item details. Status:", response.status);
    }
  };
  const handleChange = (field, value) => {
    console.log("Beoft ItemDa ta", customerData);
    setCustomerData((prev) => ({ ...prev, [field]: value }));

    console.log("affter ItemDa ta", customerData);

    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }
  };

  const handleAddressChange = (field, value, index) => {
    setCustomerData((prev) => {
      const updatedAddresses = [...prev.addresses];
      updatedAddresses[index] = {
        ...updatedAddresses[index],
        [field]: value,
      };
      return { ...prev, addresses: updatedAddresses };
    });
  };

  const handleCustomChange = (key, value) => {
    setCustomerData((prev) => ({
      ...prev,
      customFields: {
        ...prev.customFields,
        [key]: value,
      },
    }));
  };

  const customerUpdate = async (field) => {
    const response = await fetch(
      process.env.REACT_APP_CUSTOMER + "/customer/update/" + id,
      {
        method: "PUT",
        body: JSON.stringify(customerData),
        headers: headers(),
      },
    );

    if (response.ok) {
      setMessage("Customer updated successfully");
      setMessageType("success");
      handleEditToggle(field);
    }
  };

  const customFieldIcons = {
    shortName: <InfoIcon />,
  };

  const handleDelete = async () => {
    setLoading(true);
    setDialogOpen(true);
  };

  const handleDialogClose = () => (setDialogOpen(false), setLoading(false));
  const handleConfirmDelete = async () => {
    try {
      setMessageOpen(true);
      const response = await fetch(
        process.env.REACT_APP_CUSTOMER + "/customer/delete/" + id,
        {
          method: "DELETE",
          headers: headers(),
        },
      );

      if (response.ok) {
        setMessage("Customer deleted successfully");
        setMessageType("error");

        setDialogOpen(false);

        return <CustomerListPage />;
      } else {
        console.error("Failed to delete customer");
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCountries();
    customerData.addresses.forEach((address, index) => {
      if (address.country) {
        fetchStates(address.country, index);
      }
      if (address.country && address.state) {
        fetchCities(address.country, address.state, index);
      }
    });
  }, [customerData]);

  const fetchCountries = async () => {
    const response = await fetch(
      "https://countriesnow.space/api/v0.1/countries",
    );
    const data = await response.json();
    setCountries(data.data);
  };

  const fetchStates = async (country, index) => {
    const response = await fetch(
      "https://countriesnow.space/api/v0.1/countries/states",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ country }),
      },
    );
    const data = await response.json();
    setStates((prev) => ({ ...prev, [index]: data.data.states }));
  };

  const fetchCities = async (country, state, index) => {
    const response = await fetch(
      "https://countriesnow.space/api/v0.1/countries/state/cities",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ country, state }),
      },
    );
    const data = await response.json();
    setCities((prev) => ({ ...prev, [index]: data.data }));
  };

  const handleStateChange = (country, state, index) => {
    handleAddressChange("state", state, index);
    fetchCities(country, state, index);
  };

  const handleBankChange = (index, field, value) => {
    const updatedBanks = [...(customerData.bank || [])];
    updatedBanks[index] = { ...updatedBanks[index], [field]: value };

    setCustomerData((prevData) => ({
      ...prevData,
      bank: updatedBanks,
    }));
  };

  const handleBankEditToggle = (index, field) => {
    setEditMode((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        [field]: !prev[index]?.[field],
      },
    }));
  };

  const handleBlur = (field) => {
    customerUpdate(field);
    setMessage("Customer and bank details updated successfully");
    setMessageType("success");
  };

  return (
    <>
      <Header />
      <Box
        p={3}
        sx={{
          margin: "20px",
          boxShadow: 3,
          borderRadius: 2,
          background: "white",
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={3}
        >
          <Typography variant="h4" display="flex" alignItems="center" gap={2}>
            <InboxIcon /> Customer Details
          </Typography>
        </Box>

                <Tabs value={tabValue} onChange={handleTabChange} aria-label="Customer Details Tabs" centered>
                    <Tab label="Basic Info" />
                    <Tab label="Address" />
                    <Tab label="Bank" />
                </Tabs>


                
                {tabValue === 0 && (
                    <Grid container spacing={2} mt={2}>
                       
                        <Grid item xs={12}>
                            <Card>
                                <CardHeader title="Basic Information" />
                                <CardContent>
                                    {[
                                        { field: "customerName", label: "Customer Name", icon: <AccountCircleIcon /> },
                                        { field: "customerCode", label: "Customer Code", icon: <CodeIcon /> },
                                        { field: "customerEmail", label: "Email", icon: <EmailIcon /> },
                                        { field: "customerPhoneNumber", label: "Phone Number", icon: <PhoneIcon /> }
                                    ].map(({ field, label, icon }) => (
                                        <Box key={field} sx={{ display: "flex", alignItems: "center", gap: "10px", mb: 1 }}>
                                            <Box sx={{ display: "flex", alignItems: "center", minWidth: "150px" }}>
                                                {icon}
                                                <Typography variant="body1" sx={{ fontWeight: 600, ml: 1 }}>
                                                    {label}:
                                                </Typography>
                                            </Box>
                                            {editMode[field] ? (
                                                <TextField
                                                    variant="outlined"
                                                    size="small"
                                                    value={customerData[field] || ""}
                                                    onChange={(e) => handleChange(field, e.target.value)}
                                                    onBlur={() =>customerUpdate(field) }
                                                    autoFocus
                                                />
                                            ) : (
                                                <Typography
                                                    onClick={() => handleEditToggle(field)}
                                                    sx={{ cursor: "pointer", textDecoration: "underline" }}
                                                >
                                                    {customerData[field] || "N/A"}
                                                </Typography>
                                            )}
                                            <IconButton onClick={() => handleEditToggle(field)}>
                                                {editMode[field] ? "" : <EditIcon />}
                                            </IconButton>
                                        </Box>
                                    ))}
                               
                                    {customerData.customFields && Object.keys(customerData.customFields).length > 0 ? (
                                        Object.entries(customerData.customFields).map(([key, value]) => (
                                            <Box key={key} sx={{ display: "flex", alignItems: "center", gap: "10px", mb: 1 }}>
                                                <Box sx={{ display: "flex", alignItems: "center", minWidth: "150px" }}>
                                                    {customFieldIcons[key] || <InfoIcon />}
                                                    <Typography variant="body1" sx={{ fontWeight: 600, ml: 1 }}>
                                                        {key.replace(/([A-Z])/g, " $1").replace(/^./, str => str.toUpperCase())}:
                                                    </Typography>
                                                </Box>
                                                {editMode[key] ? (
                                                    <TextField
                                                        variant="outlined"
                                                        size="small"
                                                        value={value || ""}
                                                        onChange={(e) => handleCustomChange(key, e.target.value)}
                                                        onBlur={() =>customerUpdate(key) }
                                                        autoFocus
                                                    />
                                                ) : (
                                                    <Typography
                                                        onClick={() => handleEditToggle(key)}
                                                        sx={{ cursor: "pointer", textDecoration: "underline" }}
                                                    >
                                                        {value || "N/A"}
                                                    </Typography>
                                                )}
                                                <IconButton onClick={() => {
    if (editMode[key]) {
        customerUpdate(key); 
    }
    handleEditToggle(key);  
}}>
    {editMode[key] ? "" : <EditIcon />}
</IconButton>
                                            </Box>
                                        ))
                                    ) : (
                                        ""
                                    )}
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                )}


                
                {tabValue === 1 && (
                    <Grid container spacing={2} mt={2}>
                        <Grid item xs={12}>
                            <Card>
                                <CardHeader title="Address" />
                                <CardContent>
                                {customerData.addresses.map((address, index) => (
        <Box key={index} sx={{ mb: 2 }}>
          <Typography variant="h6">{address.addressType}</Typography>
          {[
            { field: "unitNumber", label: "Unit Number", icon: <ApartmentIcon /> },
            { field: "addressLine1", label: "Address Line 1", icon: <LocationOnIcon /> },
            { field: "addressLine2", label: "Address Line 2", icon: <PlaceIcon /> },
            { field: "zipcode", label: "Zip Code", icon: <PinIcon /> },
            { field: "country", label: "Country", icon: <PublicIcon /> },
            { field: "state", label: "State", icon: <FlagIcon /> },
            { field: "city", label: "City", icon: <LocationCityIcon /> }
          ].map(({ field, label, icon }) => (
            <Box key={field} sx={{ display: "flex", alignItems: "center", gap: "10px", mb: 1 }}>
              <Box sx={{ display: "flex", alignItems: "center", minWidth: "150px" }}>
                {icon}
                <Typography variant="body1" sx={{ fontWeight: 600, ml: 1 }}>{label}:</Typography>
              </Box>
              {editMode[index]?.[field] ? (
                field === "country" ? (
                  <Select
                    value={address[field] || ""}
                    onChange={(e) => {
                      handleAddressChange(field, e.target.value, index);
                      fetchStates(e.target.value, index);
                      setCities((prev) => ({ ...prev, [index]: [] })); 
                    }}
                    size="small"
                  >
                    {countries.map((c) => (
                      <MenuItem key={c.country} value={c.country}>{c.country}</MenuItem>
                    ))}
                  </Select>
                ) : field === "state" ? (
                  <Select
                    value={address[field] || ""}
                    onChange={(e) => handleStateChange(address.country, e.target.value, index)}
                    size="small"
                  >
                    {(states[index] || []).map((s) => (
                      <MenuItem key={s.name} value={s.name}>{s.name}</MenuItem>
                    ))}
                  </Select>
                ) : field === "city" ? (
                  <Select
                    value={address[field] || ""}
                    onChange={(e) => handleAddressChange(field, e.target.value, index)}
                    size="small"
                  >
                    {(cities[index] || []).map((c) => (
                      <MenuItem key={c} value={c}>{c}</MenuItem>
                    ))}
                  </Select>
                ) : (
                  <TextField
                    variant="outlined"
                    size="small"
                    value={address[field] || ""}
                    onChange={(e) => handleAddressChange(field, e.target.value, index)}
                    onBlur={() => customerUpdate(index, field)}
                    autoFocus
                  />
                )
              ) : (
                <Typography
                  onClick={() => handleEditAddressToggle(index, field)}
                  sx={{ cursor: "pointer", textDecoration: "underline" }}
                >
                  {address[field] || "N/A"}
                </Typography>
              )}
              <IconButton
                onClick={() => {
                  if (editMode[index]?.[field]) {
                    customerUpdate(index, field);
                  }
                  handleEditAddressToggle(index, field);
                }}
              >
                {editMode[index]?.[field] ? <SaveIcon /> : <EditIcon />}
              </IconButton>
            </Box>
          ))}
        </Box>
      ))}
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                )}

 
 {tabValue === 2 && (
                    <Grid container spacing={2} mt={2}>
                        <Grid item xs={12}>
                            <Card>
                                <CardHeader title="Bank Details" />
                                <CardContent>
                                {customerData.bank && customerData.bank.length > 0 ? (
                customerData.bank.map((bank, index) => (
                    <Box key={index} sx={{ mb: 2, p: 2, border: "1px solid #ccc", borderRadius: "8px" }}>
                        {[
                          {
                            field: "accountHolderName",
                            label: "Account Holder Name",
                          },
                          { field: "accountNumber", label: "Account Number" },
                          { field: "accountType", label: "Account Type" },
                          { field: "bankName", label: "Bank Name" },
                          { field: "branchName", label: "Branch Name" },
                          { field: "ifscCode", label: "IFSC Code" },
                        ].map(({ field, label }) => (
                          <Box
                            key={field}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              mb: 1,
                            }}
                          >
                            <Typography
                              sx={{ fontWeight: 600, minWidth: "150px" }}
                            >
                              {label}:
                            </Typography>

                            {editMode[index]?.[field] ? (
                              <TextField
                                variant="outlined"
                                size="small"
                                value={bank[field] || ""}
                                onChange={(e) =>
                                  handleBankChange(index, field, e.target.value)
                                }
                                onBlur={() => handleBlur(field)}
                                autoFocus
                              />
                            ) : (
                              <Typography
                                onClick={() =>
                                  handleBankEditToggle(index, field)
                                }
                                sx={{
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                }}
                              >
                                {bank[field] || "N/A"}
                              </Typography>
                            )}

                            <IconButton
                              onClick={() => handleBankEditToggle(index, field)}
                            >
                              {editMode[index]?.[field] ? (
                                <SaveIcon />
                              ) : (
                                <EditIcon />
                              )}
                            </IconButton>
                          </Box>
                        ))}
                      </Box>
                    ))
                  ) : (
                    <Typography variant="body2" color="text.secondary">
                      No bank details available.
                    </Typography>
                  )}

                  <Button
                    variant="outlined"
                    startIcon={<AddIcon />}
                    onClick={addNewBank}
                  >
                    Add Bank Details
                  </Button>

                  <Snackbar
                    open={!!message}
                    autoHideDuration={3000}
                    onClose={() => setMessage("")}
                    message={message}
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                    ContentProps={{
                      style: {
                        backgroundColor:
                          messageType === "success" ? "green" : "red",
                      },
                    }}
                  />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        )}

        <Box mt={3}>
          <Button
            variant="outlined"
            color="error"
            onClick={handleDelete}
            disabled={loading}
            startIcon={
              loading ? <CircularProgress size={20} /> : <DeleteIcon />
            }
            sx={{
              fontWeight: "bold",
              borderRadius: "8px",
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: "#f44336",
                color: "white",
                transform: "scale(1.05)",
              },
              "&:disabled": {
                backgroundColor: "#f44336",
                opacity: 0.6,
              },
            }}
          >
            {loading ? "Deleting..." : "DELETE"}
          </Button>
        </Box>
      </Box>

      <Dialog open={dialogOpen} onClose={handleDialogClose}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this customer?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="success">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="error">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <PopupMessage
        messageType={messageType}
        message={message}
        messageOpen={messageOpen}
      />
    </>
  );
};

export default ShowPage;
